<div
  class="honour-roll-widget"
  [style.background-color]="backgroundColor()"
  [style.opacity]="opacity()"
  [style.border-color]="borderColor()"
  [style.border-width]="borderWidth() + 'px'"
  [style.border-style]="borderStyle()"
>
  @if (loading()) {
    <gb-skeleton-loader
      [columns]="columns() || 5"
      [rows]="rows() || 1"
      direction="grid"
      borderRadius="0.9cqw"
      [gap]="0.7"
      gapUnit="cqw"
    ></gb-skeleton-loader>
  } @else if (showEmptyState()) {
    <gb-presenter-widget-placeholder>
      <h1>{{ 'PRESENTER.HONOUR_ROLL_WIDGET.PLACEHOLDER_TITLE' | translate }}</h1>
      <span>{{ 'PRESENTER.HONOUR_ROLL_WIDGET.PLACEHOLDER_SUBTITLE' | translate }}</span>
    </gb-presenter-widget-placeholder>
  } @else {
    <div class="carousel-viewport">
      <div
        class="carousel-track"
        [class.scroll-left]="isScrollLeft()"
        [class.scroll-right]="isScrollRight()"
        [class.scroll-top]="isScrollTop()"
        [class.scroll-bottom]="isScrollBottom()"
        [style.--carousel-duration-ms]="carouselDurationMs() + 'ms'"
        [style.--carousel-translate-percent]="carouselTranslatePercent() + '%'"
        (animationiteration)="onCarouselCycleComplete($event)"
      >
        @for (page of pagesLoop(); track $index) {
          <div
            class="honour-roll-grid carousel-page"
            [style.grid-template-columns]="gridTemplateColumns()"
            [style.grid-template-rows]="gridTemplateRows()"
          >
            @for (activity of page; track activity.uuid) {
              <ng-container *ngTemplateOutlet="cardTemplate; context: { $implicit: activity }"></ng-container>
            }
          </div>
        }
      </div>
    </div>
  }
</div>

<ng-template #cardTemplate let-activity>
  <div
    class="activity-card"
    [class.card-layout-horizontal]="cardLayoutDirection() === 'horizontal'"
    [class.card-layout-vertical]="cardLayoutDirection() === 'vertical'"
    [style.--font-scale]="fontSizeScale()"
    [style.--font-family]="fontFamily()"
    [style.--font-weight]="fontWeight()"
    [style.--text-align]="textAlign()"
    [style.background-color]="cardBackgroundColor()"
  >
    <div class="activity-image">
      @if (activity.item_image) {
        <gb-image [image]="activity.item_image" [cover]="true" />
      }
    </div>
    <div class="activity-content-wrapper">
      <div
        class="activity-content"
        [style.color]="getContrastColor(cardBackgroundColor())"
        [style.font-family]="fontFamily()"
        [style.font-weight]="fontWeight()"
        [style.text-align]="textAlign()"
      >
        <p class="activity-name">{{ activity.profile_full_name }}</p>
        <p class="activity-details" [innerHTML]="getActivityDetailsText(activity)"></p>
        <div class="activity-badge-container">
          <div class="activity-badge" [style.background-color]="primaryColor()">
            <span [style.color]="primaryColorContrast()">{{ getActivityTypeDisplayValue(activity) }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>
